var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 400,
    height: 400,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m161.01 464.01c193.21 0 298.88-160.07 298.88-298.88 0-4.546 0-9.072-0.307-13.578 20.558-14.871 38.305-33.282 52.408-54.374-19.171 8.495-39.51 14.065-60.334 16.527 21.924-13.124 38.343-33.782 46.182-58.102-20.619 12.235-43.18 20.859-66.703 25.498-19.862-21.121-47.602-33.112-76.593-33.112-57.682 0-105.14 47.464-105.14 105.14 0 8.002 0.914 15.979 2.722 23.773-84.418-4.231-163.18-44.161-216.49-109.75-27.724 47.726-13.379 109.58 32.522 140.23-16.715-0.495-33.071-5.005-47.677-13.148v1.331c0.014 49.814 35.447 93.111 84.275 102.97-15.464 4.217-31.693 4.833-47.431 1.802 13.727 42.685 53.311 72.108 98.14 72.95-37.19 29.227-83.157 45.103-130.46 45.056-8.358-0.016-16.708-0.522-25.006-1.516 48.034 30.825 103.94 47.18 161.01 47.104",
    fill: "#1da1f2",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.145d6d908a58b26f0d4c3d5a2d058c9f.svg";
export { ForwardRef as ReactComponent };